import { Component, OnInit } from "@angular/core";
import { NgbDropdownConfig } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "src/app/auth.service";
import { GetHkDateTimeService } from "src/app/helpers/get-hk-date-time.service";

@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  providers: [NgbDropdownConfig],
})
export class NavbarComponent implements OnInit {
  public iconOnlyToggled = false;
  public sidebarToggled = false;
  userName: string = "";
  userImageUrl: string = "";
  isUserAdmin: boolean = false;

  public hongKongDT;

  constructor(
    config: NgbDropdownConfig,
    private authService: AuthService,
    private hkDateTimeService: GetHkDateTimeService
  ) {
    config.placement = "bottom-right";
    this.userName = authService.getCurrentUser().userName;
    this.userImageUrl = `https://ui-avatars.com/api/?name=${this.userName}&background=B002B4&color=fff&bold=true&length=1`;
    this.isUserAdmin = authService.isUserAdmin();
  }

  ngOnInit() {
    setInterval(() => {
      this.hongKongDT = this.hkDateTimeService.getHKDateAndTime();
    }, 1000);
  }

  // toggle sidebar in small devices
  toggleOffcanvas() {
    document.querySelector(".sidebar-offcanvas").classList.toggle("active");
  }

  // toggle sidebar
  toggleSidebar() {
    let body = document.querySelector("body");
    if (
      !body.classList.contains("sidebar-toggle-display") &&
      !body.classList.contains("sidebar-absolute")
    ) {
      this.iconOnlyToggled = !this.iconOnlyToggled;
      if (this.iconOnlyToggled) {
        body.classList.add("sidebar-icon-only");
      } else {
        body.classList.remove("sidebar-icon-only");
      }
    } else {
      this.sidebarToggled = !this.sidebarToggled;
      if (this.sidebarToggled) {
        body.classList.add("sidebar-hidden");
      } else {
        body.classList.remove("sidebar-hidden");
      }
    }
  }

  // toggle right sidebar
  // toggleRightSidebar() {
  //   document.querySelector('#right-sidebar').classList.toggle('open');
  // }

  onSignoutClick = () => {
    this.authService.logoutUser();
  };
}
